/**
 * Basket Module
 * - Modern toast notifications (replaces legacy qtip2 zobrazHlaseni)
 * - Product card "in cart" visual indicator
 * - Hooks into legacy addToBasket() flow
 */

// ─── Toast System ───────────────────────────────────────────────────────────

let toastWrap = null;

function ensureToastContainer() {
  if (!toastWrap) {
    toastWrap = document.querySelector('.toast-wrap');
    if (!toastWrap) {
      toastWrap = document.createElement('div');
      toastWrap.className = 'toast-wrap';
      document.body.appendChild(toastWrap);
    }
  }
  return toastWrap;
}

function showToast(message, type = 'success') {
  const wrap = ensureToastContainer();

  const toast = document.createElement('div');
  toast.className = 'toast toast--' + type;

  const iconSvg = type === 'success'
    ? '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'
    : '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>';

  toast.innerHTML =
    '<span class="toast__icon">' + iconSvg + '</span>' +
    '<span class="toast__text">' + message + '</span>' +
    '<button class="toast__close" type="button">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" x2="6" y1="6" y2="18"/><line x1="6" x2="18" y1="6" y2="18"/></svg>' +
    '</button>';

  toast.querySelector('.toast__close').addEventListener('click', function() {
    removeToast(toast);
  });

  wrap.appendChild(toast);

  // Auto-hide after 3.5s
  setTimeout(function() { removeToast(toast); }, 3500);
}

function removeToast(toast) {
  if (!toast.parentNode) return;
  toast.classList.add('toast--hiding');
  toast.addEventListener('animationend', function() {
    if (toast.parentNode) toast.parentNode.removeChild(toast);
  });
}

// ─── Legacy Override ────────────────────────────────────────────────────────

/**
 * Override the legacy zobrazHlaseni() (qtip2-based) with modern toast.
 * The backend AJAX response (panel-kosik-ajax.tpl) calls:
 *   zobrazHlaseni('{msg}')
 * after updating #kosikContainer.
 */
function overrideZobrazHlaseni() {
  window.zobrazHlaseni = function(zprava) {
    showToast(zprava, 'success');
  };
}

// ─── Product Card "In Cart" Indicator ───────────────────────────────────────

var CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

/**
 * Mark a product card as "in cart":
 * - Green cart button with checkmark icon (spinner stays, user can change qty)
 * - Banner "máte v košíku" over the product image
 * - For variants: green variant button
 * @param {Element} card  - .product-card element
 * @param {number}  qty   - quantity in cart
 */
function markCardInCart(card, qty) {
  if (card.classList.contains('product-card--in-cart')) return;
  card.classList.add('product-card--in-cart');

  // Replace cart button icon with checkmark
  var cartBtn = card.querySelector('.btn--cart');
  if (cartBtn) {
    cartBtn.innerHTML = CHECK_SVG;
  }

  // Update spinner value to show cart quantity
  var spinnerInput = card.querySelector('.spinner__input');
  if (spinnerInput && qty) {
    spinnerInput.value = qty;
  }

  // Add banner over product image
  var imageWrap = card.querySelector('.product-card__image');
  if (imageWrap && !imageWrap.querySelector('.product-card__in-cart-banner')) {
    var banner = document.createElement('span');
    banner.className = 'product-card__in-cart-banner';
    banner.textContent = 'máte v košíku';
    imageWrap.appendChild(banner);
  }
}

/**
 * Mark a product detail page as "in cart":
 * - Green cart button
 * - Banner "máte v košíku" over the product image
 * @param {Element} detail  - .product-detail element
 * @param {number}  qty     - quantity in cart
 */
function markDetailInCart(detail, qty) {
  if (detail.classList.contains('product-detail--in-cart')) return;
  detail.classList.add('product-detail--in-cart');

  // Update spinner value
  var spinnerInput = detail.querySelector('.spinner__input');
  if (spinnerInput && qty) {
    spinnerInput.value = qty;
  }

  // Add banner over product image
  var imageWrap = detail.querySelector('.product-detail__main-img-wrap');
  if (imageWrap && !imageWrap.querySelector('.product-detail__in-cart-banner')) {
    var banner = document.createElement('span');
    banner.className = 'product-detail__in-cart-banner';
    banner.textContent = 'máte v košíku';
    imageWrap.appendChild(banner);
  }
}

/**
 * Scan all product cards and detail pages on page load.
 * Backend provides data-kosik="{kosik}" — if > 0, the product is in cart.
 */
function markCardsFromBackend() {
  var cards = document.querySelectorAll('.product-card[data-kosik]');
  for (var i = 0; i < cards.length; i++) {
    var qty = parseInt(cards[i].getAttribute('data-kosik'));
    if (qty > 0) {
      markCardInCart(cards[i], qty);
    }
  }

  // Product detail page — data-kosik is on __gallery (inside ITEMBEGIN)
  var gallery = document.querySelector('.product-detail__gallery[data-kosik]');
  if (gallery) {
    var qty = parseInt(gallery.getAttribute('data-kosik'));
    var detail = gallery.closest('.product-detail');
    if (detail && qty > 0) {
      markDetailInCart(detail, qty);
    }
  }
}

/**
 * Wrap the legacy addToBasket() to add visual feedback on product cards.
 */
function hookAddToBasket() {
  var originalAddToBasket = window.addToBasket;
  if (typeof originalAddToBasket !== 'function') return;

  window.addToBasket = function(formId, badMsg, skladem, kategorieVIP) {
    var result = originalAddToBasket.apply(this, arguments);

    try {
      var form = document.getElementById(formId);
      if (form) {
        var qty = parseInt(form.kosik.value);

        // Product card in listing
        var card = form.closest('.product-card');
        if (card && qty > 0) {
          markCardInCart(card, qty);
        }

        // Product detail page
        var detail = form.closest('.product-detail');
        if (detail && qty > 0) {
          markDetailInCart(detail, qty);
        }
      }
    } catch (e) {
      console.warn('basket.js: cart indicator error', e);
    }

    return result;
  };
}

// ─── Init ───────────────────────────────────────────────────────────────────

// ─── Product Detail Image Lightbox ──────────────────────────────────────────

function initDetailLightbox() {
  var img = document.querySelector('.product-detail__main-img[data-full]');
  if (!img) return;

  img.addEventListener('click', function(e) {
    e.preventDefault();
    var src = img.getAttribute('data-full') || img.src;

    var overlay = document.createElement('div');
    overlay.className = 'product-detail__lightbox';
    overlay.innerHTML =
      '<div class="product-detail__lightbox-content">' +
        '<img src="' + src + '" alt="' + (img.alt || '') + '"/>' +
        '<button class="product-detail__lightbox-close" type="button">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" x2="6" y1="6" y2="18"/><line x1="6" x2="18" y1="6" y2="18"/></svg>' +
        '</button>' +
      '</div>';

    overlay.addEventListener('click', function(ev) {
      if (ev.target === overlay || ev.target.closest('.product-detail__lightbox-close')) {
        overlay.classList.add('product-detail__lightbox--hiding');
        overlay.addEventListener('animationend', function() {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        });
      }
    });

    document.body.appendChild(overlay);
  });
}

/**
 * Fix empty spinner values in variant tables.
 * Backend may render {kosik} as empty string; default to min or 1.
 */
function fixVariantSpinners() {
  var inputs = document.querySelectorAll('.variants-table .spinner__input');
  for (var i = 0; i < inputs.length; i++) {
    if (!inputs[i].value || inputs[i].value === '0') {
      inputs[i].value = inputs[i].min || '1';
    }
  }
}

export function initBasket() {
  ensureToastContainer();
  overrideZobrazHlaseni();
  markCardsFromBackend();
  fixVariantSpinners();
  initDetailLightbox();

  // Hook into legacy addToBasket after a short delay
  // (legacy scripts may load after Vite module)
  if (typeof window.addToBasket === 'function') {
    hookAddToBasket();
  } else {
    // Wait for legacy scripts to load
    var checkInterval = setInterval(function() {
      if (typeof window.addToBasket === 'function') {
        clearInterval(checkInterval);
        hookAddToBasket();
      }
    }, 200);
    // Stop checking after 10s
    setTimeout(function() { clearInterval(checkInterval); }, 10000);
  }
}
